import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  VStack,
} from "@chakra-ui/react";
import { FieldError } from "react-hook-form";

const PrequalFormRow = ({
  label,
  children,
  helperText,
  fieldError,
}: {
  label: string;
  children: any;
  helperText?: string;
  fieldError?: FieldError;
}) => {
  return (
    <FormControl
      as="fieldset"
      pb="20px"
      display="flex"
      layerStyle="responsive"
      alignItems="flex-start"
      gap={{
        base: "12px",
        md: "24px",
      }}
      justifyContent="space-between"
      width={{
        base: "100%",
      }}
      isInvalid={fieldError ? true : false}
    >
      <VStack alignItems="flex-start" flex="3" gap="0px">
        <FormLabel mb="0px">{label}</FormLabel>
        {helperText && <FormHelperText mb="0px">{helperText}</FormHelperText>}
      </VStack>
      <VStack
        flex="2"
        alignItems={{
          base: "flex-start",
          lg: "flex-end",
        }}
        gap="0px"
        w="100%"
      >
        {children}
        <FormErrorMessage>{fieldError && fieldError.message}</FormErrorMessage>
      </VStack>
    </FormControl>
  );
};

export default PrequalFormRow;
